import '@vfde-brix/helpful/dist/styles.css';
import '@vfde-brix/button/dist/styles.css';
import '@vfde-brix/notification/dist/styles.css';
import { createHelpfulComponent } from '@vfde-brix/helpful';
import { NO_PATTERN_BUSINESS_LOGIC } from '@vfde-brix/core';
import { createComponents } from '../../utils/initComponents';

createComponents('brix-helpful', createHelpfulComponent, NO_PATTERN_BUSINESS_LOGIC);
